import api from './api';

export const getOverview = () =>
  api.get('/admin/affiliates/overview').then(r => r.data);

export const getGrouped = () =>
  api.get('/admin/affiliates/grouped').then(r => r.data.partners);

export const getByMember = (memberId) =>
  api.get(`/admin/affiliates/by-member/${memberId}`).then(r => r.data);

export const getSegmentCounts = () =>
  api.get('/admin/affiliates/segment-counts').then(r => r.data);

export const bulkEmail = (fields) =>
  api.post('/admin/affiliates/bulk-email', fields).then(r => r.data);
